import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
const useRootAppStore = () => {
    const store = useContext(MobXProviderContext);
    if (!store) {
        throw new Error('useStore must be used within a StoreProvider.');
    }
    return store;
};
export default useRootAppStore;
//# sourceMappingURL=use-root-app-store.js.map